<div class="rs-flex-column" *ngIf="exceedingAmount">
  <p
    [ngClass]="
      overriddenClasses
        ? overriddenClasses
        : 'rs-txt-s3 rs-txt-error rs-padding-left1 rs-padding-bottom1 rs-font-pxB rs-nowrap'
    "
  >
    + <px-currency-amount [amount]="exceedingAmount"></px-currency-amount>
    <!-- <span
      class="has-tip"
      data-tooltip=""
      title="{{ 'usage.exceeding.amount.help.tooltip' | translate }}"
    >
      <i class="icon-Help icon-lh rs-valign-top rs-margin-left1"></i>
    </span>-->
  </p>
</div>
